'use strict'

const getInputComponents = require('./getInputComponents')
const {
  DROPDOWN_OPTIONS_ROLE
} = require('dbsm-common/src/connection-config/roles')

module.exports = contexts =>
  getInputComponents(
    contexts.filter(({ role }) => role !== DROPDOWN_OPTIONS_ROLE)
  )



// WEBPACK FOOTER //
// ./helpers/getDisableableInputComponents.js